module.exports = __webpack_public_path__ + "img/36.db76f5ff.jpg";